import { CheckCircle, Error } from '@mui/icons-material';
import { Link, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function CheckIcon({ checked }) {
  return checked ? <CheckCircle color="success" /> : <Error color="warning" />;
}

CheckIcon.propTypes = { checked: PropTypes.bool.isRequired };

/** @param { import('prop-types').InferProps<typeof SubmissionPrerequisitesPropTypes>} props */
export default function SubmissionPrerequisites({ inDiscordGuild, discordAccountLinked }) {
  // Not using useAuth because the parent needs to validate first anyway to display this component
  const { t } = useTranslation();

  return (
    <>
      <Typography>{t('run.submit.prerequisites.description')}</Typography>
      <Stack sx={{ gap: 0.5, padding: 2 }}>
        <Stack direction="row" alignItems="center" gap={1}>
          <CheckIcon checked={inDiscordGuild} />
          <Link href="https://discord.noreset.tv" target="_blank" rel="noopener noreferrer">
            {t('run.submit.prerequisites.joinDiscord')}
          </Link>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          <CheckIcon checked={discordAccountLinked} />
          <Link href="/profile">{t('run.submit.prerequisites.linkDiscord')}</Link>
        </Stack>
      </Stack>
      <Typography>{t('run.submit.prerequisites.rejectionWarning')}</Typography>
    </>
  );
}

const SubmissionPrerequisitesPropTypes = {
  discordAccountLinked: PropTypes.bool.isRequired,
  inDiscordGuild: PropTypes.bool.isRequired,
};
SubmissionPrerequisites.propTypes = SubmissionPrerequisitesPropTypes;
